module.exports = __webpack_public_path__ + "static/img/jiankang.6122471c.png";